<template>
  <!-- 中标跟进流程详情 -->
  <div class="bid-follow-process-detail">
    <div class="title">
      中标跟进审批进度（ {{details.Code}} ）
    </div>
    <div v-if="JSON.stringify(listData)!='{}'">
      <div class="detail">
        <sub-title title="中标项目"></sub-title>
        <div class="project">
          <div class="project-item" v-for="item in (listData&&listData.BidProjects)" :key="item.ID">
            <span class="project-item-name">
              {{item.Name}}
            </span>
            <div class="project-item-info">
              <div class="project-item-info-item">
                <span>中标金额：</span>
                <span>{{item.BidAmountStr}}</span>
              </div>
              <div class="project-item-info-item">
                <span>中标日期：</span>
                <span>{{$common.timesToTime(item.NoticeDate)}}</span>
              </div>
              <div class="project-item-info-item">
                <span>中标单位：</span>
                <span>{{item.BidCompanyName}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="process">
        <sub-title title="审批进度"></sub-title>
        <div class="flow-box">
          <flow-chart :details="listData" :TemplateID="TemplateID" :selTab="type" passTip='您是否通过所有中标跟进项目' rejectTip='所有中标跟进项目' @close="$emit('refresh')" v-if="JSON.stringify(listData)!='{}'"></flow-chart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WorkflowQuery } from '@/http/api'
export default {
  name: 'BidFollowProcessDetail',
  props: ['ID', 'TemplateID', 'type'],
  data() {
    return {
      listData: {}
    }
  },
  watch: {
    ID: {
      handler(val) {
        if (val) {
          this.$emit('loading', true)
          WorkflowQuery(
            {
              workflowId: this.ID,
              templateId: this.TemplateID,
            },
            'Get'
          ).then((res) => {
            if (!!res && JSON.stringify(res) != "{}") this.listData = res;
            this.$emit('loading', false)
          })
        }
      },
      immediate: true,
    },
  },
  methods: {

  },
}
</script>
<style lang="less" scoped>
@import "./details.less";
</style>